import { Component, Input, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationItem } from '../models/navigation-item.model';

@Component({
  selector: 'app-navigation-item',
  imports: [CommonModule, RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './navigation-item.component.html',
  styleUrl: './navigation-item.component.css'
})
export class NavigationItemComponent {

  item = input.required<NavigationItem>();

  minimized = input<boolean>(false);

  @Input() onActiveLink?: (title: string, icon: string) => void;

  onActive() {
    if (this.onActiveLink) {
      this.onActiveLink(this.item()?.title, this.item()?.icon);
    }
  }

}
